export enum ProfileSection {
  PERSONAL_DATA = 'personal-data',
  CONTACTS = 'contacts',
  ADDRESS = 'address',
  BANK_DETAILS = 'bank-details',
}
